
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import Vuetify from 'vuetify';
    import vuetify from '@/__env/pluggins/vuetify';
    import { ControladorInterfaz } from '@view/a-pedido-cargar/controlador';
    import { } from '@view/a-pedido-cargar/controlador-item';
    import { Item } from '@view/a-pedido-cargar/controlador-pedido';

    import jexcel from 'jexcel';
    import jQuery from 'jquery';
    import 'jexcel/dist/jexcel.css';
    import { Articulo } from '@/__env/lib/Articulos';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    
    /*CELDAS*/
    import celda_descripcion from './tabla-celda-descripcion.vue';
    import celda_descuentos from './tabla-celda-descuentos.vue';
    import celda_importes from './tabla-celda-importes.vue';
    import { Controlador } from '@/views/a-publicaciones-ml/pc/lista/controlador';
    import { isNumber } from 'util';

    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Estado() { return this.Controlador.Vista.Estado; }
        public get Iniciado() { return this.Controlador.EdicionPedido.Iniciado; }
        public get ReservaEspacioAbajo() { return this.Controlador.Vista.BarraDebajo.Altura.Espacio; }
        public get ReservarEspacioIzquierda() { return this.Controlador.Vista.BarraIzquierda.Anchura.Espacio; }
        public get Buscando() { return this.Controlador.Vista.BarraIzquierda.Estado == 'buscador'; }
        public get Items()
        {
            return this.Controlador.EdicionPedido.Items;
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );

        }

        mounted()
        {
            this.Eventos.push( this.Controlador.onReiniciarTabla.subscribe( () => this.Reiniciar() ) );
            this.Eventos.push( this.Controlador.EdicionPedido.NuevoItem.onAgregarItem.subscribe( ( item, index ) => this.AgregarItem( item, index ) ) );
            this.Eventos.push( this.Controlador.EdicionPedido.NuevoItem.onEditarItem.subscribe( ( item, index ) => this.EditarItem( item, index ) ) );
            this.Eventos.push( this.Controlador.EdicionPedido.NuevoItem.onEliminarItem.subscribe( ( item, index ) => this.EliminarItem( item, index ) ) );
            this.Eventos.push( Utiles.onKeyUp.subscribe( e => this.onKeyUp( e ) ) );
            this.Eventos.push( Utiles.onKeyDown.subscribe( e => this.onKeyDown( e ) ) );
            this.Iniciar();
        }

        public Focused: boolean = false;
        SpreadSheet: any = null;
        async Reiniciar()
        {
            this.SpreadSheet.setData( {} );
            this.SpreadSheet.refresh();
        }

        async Iniciar()
        {
            var options = {
                allowToolbar: false,
                columnSorting: false,
                columnDrag: false,
                columnResize: false,
                rowResize: false,
                rowDrag: false,
                allowManualInsertRow: false,
                allowInsertColumn: false,
                allowManualInsertColumn: false,
                allowDeleteColumn: false,
                allowDeleteRow: true,
                selectionCopy: false,
                search: false,
                minDimensions: [1, 1],
                tableOverflow: true,
                tableWidth: "100vw",
                defaultRowHeight: 40,
                onbeforechange: this.TableOnChange,
                onfocus: () => this.Focused = true,
                onblur: () => this.Focused = false,
                onselection: this.TableOnSelection,
                onpaste: this.onPaste,
                columns: [
                    //{ type: 'text', title: '#', width: '1', readOnly: true },
                    { type: 'text', title: 'Codigo', width: '1' },
                    { type: 'text', title: 'Cantidad', width: '2', decimal: '.', readOnly: true },
                    { type: 'html', title: 'Descripción', width: '3', readOnly: true, 'text-align': 'left' },
                    { type: 'html', title: '%', width: '4', readOnly: true, 'text-align': 'left' },
                    { type: 'html', title: 'Importe', width: '5', readOnly: true },

                ]
            };

            let spreadsheet = jexcel( document.getElementById( 'tabla-items' ), options );
            this.SpreadSheet = spreadsheet;
            Object.assign( this, { spreadsheet } );

            jQuery( 'col[width="1"]' ).css( 'width', '125px' );
            jQuery( 'col[width="2"]' ).css( 'width', '100px' );
            jQuery( 'col[width="3"]' ).css( 'width', 'calc( 100vw - 50px - 125px - 100px - 110px - 250px)' );
            jQuery( 'col[width="4"]' ).css( 'width', '100px' );
            jQuery( 'col[width="5"]' ).css( 'width', '240px' );

            //this.SpreadSheet.insertRow( 1, i, false );
            //this.AgregarItems();


        }


        public get ItemSeleccionado()
        {
            if ( this.Seleccion.y >= 0 && this.Controlador.EdicionPedido.Items[this.Seleccion.y] )
                return this.Controlador.EdicionPedido.Items[this.Seleccion.y];
            return null;
        }
        public Seleccion: {
            x: number;
            y: number;
        } = { x: -1, y: -1 };

        protected TableOnSelection( instance: string, x: number, y: number )
        {
            if ( this.Seleccion.x != Number( x ) )
            {
                this.Seleccion.x = Number( x );
                this.$emit( 'seleccion-x', x );
            }

            if ( this.Seleccion.y != Number( y ) )
            {

                this.Seleccion.y = Number( y );
                if ( this.ItemSeleccionado )
                {
                    this.Controlador.ArticuloSeleccionado = this.ItemSeleccionado.Articulo;
                    if ( this.Controlador.Configuracion.Opciones.PanelDetalleArticulos.Abrir == 'siempre' || ( !this.$vuetify.breakpoint.mdAndDown && this.Controlador.Configuracion.Opciones.PanelDetalleArticulos.Abrir == 'resolucion' ) )
                    {
                        this.Controlador.Vista.BarraDerecha.Modo = 'articulo-detalles';
                    }
                }

                this.$emit( 'seleccion-y', y );

            }
        }

        protected async onKeyDown( x: KeyboardEvent )
        {
            if ( ( x.key == 'ArrowLeft' && x.ctrlKey ) || ( x.key == 'ArrowRight' && x.ctrlKey ) )
            {
                x.preventDefault();
            }
        }

        protected async onKeyUp( x: KeyboardEvent )
        {
            if ( this.Focused )
            {
                //console.log( x );
                if ( x.code == 'Space' )
                {
                    if ( this.ItemSeleccionado )
                    {
                        let e = await this.Controlador.EdicionPedido.NuevoItem.SiguientePrecio( this.ItemSeleccionado, x.ctrlKey );
                        if ( e.Mensaje )
                            Utiles.Notificaciones.Error( e.Mensaje );
                    }
                }
                else if ( x.key == '+' && x.ctrlKey )
                {
                    if ( this.ItemSeleccionado )
                    {
                        if ( this.Controlador.Vista.BarraDerecha.Modo == 'articulo-detalles' )
                            this.Controlador.Vista.BarraDerecha.Modo = '';
                        else
                        {
                            this.Controlador.ArticuloSeleccionado = this.ItemSeleccionado.Articulo;
                            this.Controlador.Vista.BarraDerecha.Modo = 'articulo-detalles';
                        }
                    }
                }
                else if ( x.code == 'Delete' )
                {
                    if ( this.ItemSeleccionado )
                    {
                        if ( await this.$EventBus.Mensajes.SiNo( '¿Eliminar el item actual?', this.ItemSeleccionado.Articulo.Id + ' se eliminará' ) )
                        {
                            this.Controlador.EdicionPedido.NuevoItem.Eliminar( this.Seleccion.y );
                            this.SpreadSheet.resetSelection( true );
                        }

                    }
                }
                else if ( x.code == 'Tab' )
                {
                    this.SpreadSheet.resetSelection( true );
                    this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
                }
                else if ( x.key == 'F3' || ( x.key == 'f' && x.ctrlKey ) )
                {
                    this.SpreadSheet.resetSelection( true );
                    this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
                }
            }
            else if ( x.code == 'Tab' )
            {
                //if ( this.ItemSeleccionado )
                //    this.SpreadSheet.updateSelectionFromCoords( 1, this.ItemSeleccionado.Posicion, 1, this.ItemSeleccionado.Posicion );
                //else
                //    this.SpreadSheet.updateSelectionFromCoords( 1, 0, 1, 0 );
            }

        }

        BuscarArticulo( articulo: string )
        {
            let data = this.SpreadSheet.getData() as Array<any>;
            for ( var i = 0; i < data.length; i++ )
            {
                if ( String( data[i][0] ) == articulo )
                    return i;
            }
            return -1;
        }

        protected Celdas: Record<number, Vue[]> = {};
        AgregarItem( item: Item, row: number )
        {
            if ( this.BuscarArticulo( item.Articulo.Id )  > -1)
                return;

            document.querySelectorAll( `td[data-x="0"][data-y="${row}"]` ).forEach( x => { x.className += ' readonly'; } );
            if ( !item.NoModificable )
                document.querySelectorAll( `td[data-x="1"][data-y="${row}"]` ).forEach( x => { x.className = x.className.replace( 'readonly', '' ); } );
            this.SpreadSheet.setValueFromCoords( 0, row, item.Articulo.Id, true );
            this.SpreadSheet.setValueFromCoords( 1, row, item.Cantidad + ' u.', true );
            this.SpreadSheet.setValueFromCoords( 2, row, `<div id="descripcion-id-${row}"></div>`, true );
            this.SpreadSheet.setValueFromCoords( 3, row, `<div id="descuentos-id-${row}"></div>`, true );
            this.SpreadSheet.setValueFromCoords( 4, row, `<div id="importes-id-${row}"></div>`, true );


            if ( this.Celdas[row] )
            {
                for ( let celda of this.Celdas[row] )
                {
                    celda.$destroy();
                }
            }

            Vue.use( Vuetify );
            let celda1 = Vue.extend( celda_descripcion );
            let celda2 = Vue.extend( celda_descuentos );
            let celda3 = Vue.extend( celda_importes );
            this.Celdas[row] = [
                new celda1( { propsData: { Item: item, Posicion: row, Controlador: this.Controlador }, vuetify: vuetify } ).$mount( '#descripcion-id-' + row ),
                new celda2( { propsData: { Item: item, Posicion: row, Controlador: this.Controlador }, vuetify: vuetify } ).$mount( '#descuentos-id-' + row ),
                new celda3( { propsData: { Item: item, Posicion: row, Controlador: this.Controlador }, vuetify: vuetify } ).$mount( '#importes-id-' + row ),
            ];

            this.SpreadSheet.insertRow( 1, this.Items.length, false );
        }

        EditarItem( item: Item, row: number )
        {
            document.querySelectorAll( `td[data-x="0"][data-y="${row}"]` ).forEach( x => { x.className += ' readonly'; } );
            document.querySelectorAll( `td[data-x="1"][data-y="${row}"]` ).forEach( x => { x.className = x.className.replace( 'readonly', '' ); } );
            this.SpreadSheet.setValueFromCoords( 0, row, item.Articulo.Id, true );
            this.SpreadSheet.setValueFromCoords( 1, row, item.Cantidad + ' u.', true );
        }

        EliminarItem( item: Item, row: number )
        {
            if ( this.Celdas[row] )
            {
                for ( let celda of this.Celdas[row] )
                {
                    celda.$destroy();
                }
            }

            //if ( this.Focused )
            //{
            //    this.$nextTick( () =>
            //    {
            //        this.SpreadSheet.updateSelectionFromCoords( 0, row, 0, row );
            //    } );
            //}

            this.SpreadSheet.deleteRow( row, 1 );
        }

        async AgregarNuevoItem( codigo: string )
        {
            let res = await this.Controlador.EdicionPedido.NuevoItem.Agregar( codigo );
            //console.log( res );
            if ( res.Resultado )
            {
                this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
                this.Controlador.ArticuloSeleccionado = this.ItemSeleccionado.Articulo;
                if ( this.Focused )
                {
                    this.$nextTick( () =>
                    {
                        this.SpreadSheet.updateSelectionFromCoords( 1, res.Index, 1, res.Index );
                    } );
                }

            } else
            {
                if ( this.Focused )
                {
                    if ( res.Mensaje )
                        Utiles.Notificaciones.Error( res.Mensaje );

                    await Wait( 100 );
                    this.$nextTick( () =>
                    {
                        this.SpreadSheet.updateSelectionFromCoords( 0, res.Index, 0, res.Index );
                    } );
                }


            }
        }

        async EditarCantidad( cantidad: number, row: number )
        {
            if ( this.Controlador.EdicionPedido.Items[row] )
            {
                await Wait( 10 );

                let res = await this.Controlador.EdicionPedido.NuevoItem.Agregar( null, cantidad, row );
                if ( res.Resultado )
                {
                    this.Controlador.Vista.BarraIzquierda.Modo = 'articulo';
                    if ( this.Focused )
                    {
                        this.$nextTick( () =>
                        {
                            this.SpreadSheet.updateSelectionFromCoords( 0, res.Index + 1, 0, res.Index + 1 );
                        } );
                    }
                    return true;

                } else
                {
                    if ( res.Mensaje )
                        Utiles.Notificaciones.Error( res.Mensaje );
                    return false;
                }
            }
        }


        onPaste( instance: string, cell: { col: number, newValue: string, row: number, x: string, y: string; }[] ): any
        {
            if ( !this.Controlador.EdicionPedido.Iniciado )
                return '';

            if ( cell && cell.hasRows() )
            {
                for ( let cel of cell )
                {
                    let col = parseInt( cel.x );
                    let row = parseInt( cel.y );
                    let value = cel.newValue;
                    if ( col == 0 && value )
                    {
                        this.AgregarNuevoItem( value );
                        return '';
                    }
                    else if ( col == 1 && value && parseFloat( value.borraLetras() ) > 0 )
                    {
                        this.EditarCantidad( parseFloat( value.borraLetras() ), row );
                        return '';
                    }

                }
            }


        }

        TableOnChange( instance: string, cell: HTMLTableCellElement, x: string | number, y: string | number, value: string ): any
        {
            if ( !this.Controlador.EdicionPedido.Iniciado )
            {
                Utiles.Notificaciones.Error( 'No hay un pedido seleccionado' );
                return '';
            }

            let col = isNumber( x ) ? x : parseInt( x );
            let row = isNumber( y ) ? y : parseInt( y );
            //console.log( col, row, value );
            if ( col == 0 && !cell.className.includes( 'readonly' ) )
            {
                let manual = document.querySelector( '#tabla-items input' );
                if ( manual )
                {
                    this.AgregarNuevoItem( value );
                    return '';
                }
            }
            else if ( col == 1 )
            {
                if ( !cell.className.includes( 'readonly' ) )
                {

                    let manual = document.querySelector( '#tabla-items input' );
                    if ( manual )
                    {
                        this.EditarCantidad( parseFloat( value.borraLetras() ), row );
                        return this.Controlador.EdicionPedido.Items[row].Cantidad + ' u.';
                    } else
                    {
                        return this.Controlador.EdicionPedido.Items[row].Cantidad + ' u.';
                    }
                }
            }

            return value;
        }

    }
